import { React, UseState, UseEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PageContent from 'layouts/PageContent';
import BacklogByDivision from './BacklogByDivision';

const BacklogByDivisionScreen = (props) => {
  const {t, i18n} = useTranslation(['salesPerformance', 'common']);
  
  return (
    <PageContent title={t('salesPerformance:BacklogByDivision')}>
      <BacklogByDivision />
    </PageContent>
  )
}

export default BacklogByDivisionScreen;